<template>
  <div id="entire-header">
    <div class="title-and-logo">
      <div id="page-title">Inmate Search</div>
      <img class="logo" src="../../public/county-logo.png" />
    </div>
    <div class="break-line"></div>
  </div>
</template>

<script>
import { eventBus } from "../main.js";

export default {
  data() {
    return {};
  },
  methods: {
    // General Utility Methods

    // Call this to open the modal window after setting the values in the store
    modalOpen() {
      this.$nextTick(() => {
        eventBus.$emit("openModalWindow");
      });
    },

    // Run this before OR after each use of the modal window (use the same choice for every use of the modal window)
    resetModalWindow() {
      eventBus.$emit("clearModalData");
    },
  },
  created() {},
};
</script>

<style>
#entire-header {
  /* background-image: url("../assets/JMACS_Background.png"); */
  display: block;
  width: 100%;
  /* height: 150px; */
  /* position: absolute; */
  /* left: 0;
  top: 5px; */
  color: rgb(18, 27, 102);
  /* border-bottom: solid 1px rgb(150, 150, 150); */
  /* border: ridge; */
  margin: auto;
  margin-top: -40px;
}

#page-title {
  font-size: 50px;
  /* text-align: left bottom; */
  /* margin: 30px 0 5px; */
  margin: auto auto auto 10px;
}

.break-line {
  border-bottom: solid 1px rgb(180, 180, 180);
  width: 80%;
  justify-content: center;
  position: relative;
  left: 10%;
}

.logo {
  max-height: 120px;
  max-width: 400px;
  margin: auto 10px auto auto;
  /* position: absolute; */
  /* right: 17%; */
  /* top: 0; */
}

.title-and-logo {
  display: flex;
  margin: auto;
  /* justify-content: space-between; */
  flex-wrap: wrap-reverse;
  width: 80%;
  margin-bottom: 5px;
}

.spacer-div {
  margin: auto;
}

/* This section makes sure the title and image stack in the center */
@media screen and (max-width: 1000px) {
  .logo {
    margin: auto;
    max-width: 300px;
  }

  #page-title {
    margin: auto;
  }
}
</style>